import "./standardPlatformWizard.js";
import "./standardPlatformFacilitySetupWizard.less";
import "./detailsInfo.js";



// WEBPACK FOOTER //
// ./src/pages/standardPlatformFacilitySetupWizard/index.js